/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentEditorDiscountViewModel } from "../types/IndividualPaymentEditorDiscountViewModel.ts";

export const individualPaymentEditorDiscountViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  active: z.optional(z.boolean()),
  description: z.string().nullish(),
  discountTypeId: z.optional(z.number().int()),
  percentage: z.optional(z.number()),
  deleteJustification: z.string().nullish(),
  discountTypeText: z.string().nullish(),
  retroactive: z.optional(z.boolean()),
  approved: z.optional(z.boolean()),
  associatedCompanyId: z.number().int().nullish(),
  mustSelectAssociatedCompany: z.optional(z.boolean()),
  associatedCompanyValidateDocument: z.optional(z.boolean()),
  companyName: z.string().nullish(),
  associatedCompany: z.string().nullish(),
}) as unknown as ToZod<IndividualPaymentEditorDiscountViewModel>;
